<template>
	<div>
		<div class="d-flex align-items-center mb-3">
			<div>
				<h1 class="page-header mb-0"><i class="fa fa-arrow-down-up-across-line"></i> Emelőgép napló</h1>
			</div>
		</div>
		<panel title="Emelőgép kulcs napló">
			<Loading title="Berendezések betöltése" v-if="!logs"></Loading>
			<div v-else>
				<vue-good-table :columns="columns" :rows="logs"
					:search-options="{ enabled: false, placeholder: 'Keresés...' }" :pagination-options="{
						enabled: true,
						position: 'bottom',
						firstLabel: 'Első Lap',
						lastLabel: 'Utolsó Lap',
						nextLabel: 'következő',
						prevLabel: 'előző',
						rowsPerPageLabel: 'Sor oldalanként',
						ofLabel: '/',
						dropdownAllowAll: false,
						allLabel: 'Összes',
					}">
					<template slot="table-row" slot-scope="props">
						<span v-if="props.column.field == 'created_at'">
							{{ props.row.created_at | moment('YYYY-MM-DD, HH:mm') }}
						</span>
						<span v-else-if="props.column.field == 'task_id'">
							<router-link :to="'/tasks/'+props.row.task_id+'/edit'" class="btn btn-dark btn-xs" title="munkafolyamathoz">{{ props.row.task_id }} <i class="fa fa-paper-plane"></i></router-link>
						</span>
						<span v-else-if="props.column.field == 'comment'">
							<span v-if="props.row.comment">
								<b><i class="fa fa-times-circle me-1 text-red"></i>nem </b> {{ props.row.comment }}
							</span>
							<span v-else><i class="fa fa-check-circle me-1 text-green"></i>igen</span>
						</span>
						<span v-else>
							{{ props.formattedRow[props.column.field] }}
						</span>
					</template>
				</vue-good-table>
			</div>
		</panel>
	</div>
</template>

<script>
import Loading from '../../components/Loading';
import Log from "../../apis/Log";
export default {
	components: {
		Loading
	},
	data() {
		return {
			logs: false,
			columns: [
			{
					label: 'Mf. száma',
					field: 'task_id',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés',
					},
					tdClass: 'fw-bold text-center',
					thClass: 'fw-bold text-center',
				},
				{
					label: 'Munkafolyamat megnevezése',
					field: 'task_name',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés',
					},
					width: '20%',
				},
				{
					label: 'Emelőgép szám',
					field: 'crane_number',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés',
					}
				},
				{
					label: 'Emelőgép neve',
					field: 'crane_name',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés',
					}
				},
				{
					label: 'Felvevő operátor',
					field: 'operator_name_out',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés',
					}
				},
				{
					label: 'Felvevő munkavállaló',
					field: 'user_name_out',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés',
					}
				},
				{
					label: 'Kulcs felvéve',
					field: 'taken_at',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés',
					}
				},
				{
					label: 'Visszahozó operátor',
					field: 'operator_name_in',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés',
					}
				},
				{
					label: 'Visszahozó munkavállaló',
					field: 'user_name_in',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés',
					}
				},
				{
					label: 'Kulcs visszahozva',
					field: 'returned_at',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés',
					}
				},
				{
					label: 'Üzemképes',
					field: 'comment',
					filterOptions: {
						filterDropdownItems: [
							{ value: 'y', text: 'igen' },
							{ value: 'n', text: 'nem' },
						],
						enabled: true,
						placeholder: 'Mind',
						filterFn: function(data, filterString) {
							if(filterString == 'y'){
								return data == null
							}else{
								return data != null
							}
						}
					}
				},
			],
			errors: [],
		}
	},
	created() {
		this.loadItems();
	},
	methods: {
		loadItems() {
			Log.craneLogs().then(response => {
				this.logs = response.data;
			});
		}
	}
}
</script>

<style></style>